import { render, staticRenderFns } from "./SubGoodsEdit.vue?vue&type=template&id=277da4f1&scoped=true&"
import script from "./SubGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./SubGoodsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277da4f1",
  null
  
)

export default component.exports